import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, UseFormSetValue, useWatch } from 'react-hook-form';

import { CruiseRescheduleFormType } from '../../form-type';

function reducer(
  state,
  action,
  { setValue }: { setValue: UseFormSetValue<any> },
) {
  switch (action.type) {
    case 'update_cell':
      return {
        ...state,
        data: state.data.map((row, index) => {
          if (index === action.rowIndex) {
            let columnId:
              | 'cruiseId'
              | 'cruiseShipId'
              | 'startedAt'
              | 'endedAt'
              | 'route' = action.columnId;

            if (action.columnId === 'departureTime') {
              columnId = 'startedAt';
            } else if (action.columnId === 'arrivalTime') {
              columnId = 'endedAt';
            }

            const tempVal = {
              ...state.data[action.rowIndex],
              [action.columnId]: action.value,
            };
            setValue(`cruiseSales.0.departureTime`, undefined, {
              shouldValidate: true,
              shouldTouch: true,
            });
            setValue(`cruiseSales.0.arrivalTime`, undefined, {
              shouldValidate: true,
              shouldTouch: true,
            });
            setValue(`cruiseSales.0.${columnId}`, action.value, {
              shouldValidate: true,
              shouldTouch: true,
            });
            return tempVal;
          }
          return row;
        }),
      };
    case 'update_all':
      return {
        ...state,
        data: action.newData,
      };
    default:
      return state;
  }
}

const _columns: (props: { t: any }) => IColumn<any>[] = ({ t }) => [
  {
    header: t('common:cruise_line'),
    accessorKey: 'cruiseName',
    minSize: 180,
    maxSize: 200,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('cruise:ship'),
    accessorKey: 'cruiseShipName',
    minSize: 180,
    maxSize: 200,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:from'),
    accessorKey: 'startedAt',
    minSize: 150,
    maxSize: 150,
    required: true,
    dataType: ColumnDataType.date,
  },
  {
    header: t('common:to'),
    accessorKey: 'endedAt',
    minSize: 150,
    maxSize: 150,
    required: true,
    dataType: ColumnDataType.date,
  },
  {
    header: t('common:departure'),
    accessorKey: 'departureTime',
    minSize: 100,
    maxSize: 150,
    required: true,
    dataType: ColumnDataType.time,
  },
  {
    header: t('common:arrival'),
    accessorKey: 'arrivalTime',
    minSize: 100,
    maxSize: 150,
    required: true,
    dataType: ColumnDataType.time,
  },
  {
    header: t('common:route'),
    accessorKey: 'route',
    minSize: 100,
    required: true,
    dataType: ColumnDataType.text,
  },
];

export default function NewCruiseTable() {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const { setValue, control } = useFormContext<CruiseRescheduleFormType>();

  const name = 'cruiseSales';
  const cruiseSaleValue = useWatch({ control, name });
  const [isInitiate, setIsInitiate] = React.useState<boolean>(false);
  const columns = _columns({ t });
  const [state, dispatch] = React.useReducer(
    (state, action) => reducer(state, action, { setValue }),
    {
      columns,
      data: [],
    },
  );

  React.useEffect(() => {
    if (!isInitiate) {
      const val = [
        {
          ...cruiseSaleValue[0],
          departureTime: cruiseSaleValue[0].startedAt,
          arrivalTime: cruiseSaleValue[0].endedAt,
        },
      ];
      dispatch({
        type: 'update_all',
        newData: val,
      });
      setIsInitiate(true);
    }
  }, [cruiseSaleValue, isInitiate]);

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={state.data}
        dispatch={dispatch}
        disabled={!editable}
        noAddRemoveRow
        name={name}
        uniqueRowKey="customId"
      />
    </div>
  );
}
